import gql from 'graphql-tag';

export const AdminUpdatePostMutation = gql`
  mutation AdminUpdatePost($id: Int!, $payload: updatePostPayloadInput) {
    updatePost(id: $id, payload: $payload) {
      id
      title
      subtitle
      content
      published
      featuredImageUrl
      publishedAt
      createdAt
      updatedAt
    }
  }
`;

export const AdminArchivePostMutation = gql`
  mutation AdminArchivePost($id: Int!) {
    updatePost(id: $id, payload: { published: false }) {
      id
      title
      content
      published
      featuredImageUrl
      publishedAt
      createdAt
      updatedAt
    }
  }
`;

export const AdminBatchArchivePostsMutation = gql`
  mutation AdminBatchArchivePosts($ids: [Int!]) {
    deletePosts(ids: $ids, all: false, hardDelete: false) {
      ids
    }
  }
`;
